









































import { defineComponent } from '@nuxtjs/composition-api';
import BaseBadge from '@shared/components/@atoms/BaseBadge/BaseBadge.vue';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';

export default defineComponent({
  name: 'BaseColor',
  inject: {
    components: {
      default: {
        BaseBadge,
        BaseIcon,
        BaseButton,
      },
    },
  },
  props: {
    color: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    hasBadge: {
      type: Boolean,
      default: true,
    },
  },
  data(...args): any {
    return args;
  },
});
